<template>
  <div>
    <div class="msg-list">
      <div style="margin-right: 10px;">
        <el-radio
          v-for="(text, key) in errorMsgOptions.slice(0,5)"
          :key="key"
          :title="text"
          v-model="currentValue"
          :label="text">{{text}}
        </el-radio>
      </div>
      <div>
        <el-radio
          v-for="(text, key) in errorMsgOptions.slice(5,10)"
          :key="key"
          :title="text"
          v-model="currentValue"
          :label="text">{{text}}
        </el-radio>
      </div>
    </div>

    <div v-if="messages.length">
      <p>自定义错误选项</p>
      <div class="msg-list"
           style="display: block;">
        <template v-for="(text, key) in messages">
          <el-radio
            :title="text"
            v-model="currentValue"
            :label="text">{{text}}
          </el-radio>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import errorMsgOptions from './error-msg-options.js'

export default {
  mixins: [],
  components: {},
  props: {
    value: String,
    messages: {
      type: Array,
      default: [],
    },
  },
  data () {
    return {
      currentValue: '',
      errorMsgOptions: errorMsgOptions,
    }
  },
  computed: {},
  watch: {
    value () {
      if (this.value !== this.currentValue) {
        this.currentValue = this.value
      }
    },
    currentValue () {
      if (this.value !== this.currentValue) {
        this.$emit('input', this.currentValue)
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/ReviewBox/src/ErrorMessageList.vue